




import { Component, Mixins } from "vue-property-decorator";
import {
  IUserDefinitionItem,
  instanceOfIUserDefinitionItem,
  instanceOfITextDrawable,
  IItem,
  AbstractPlainTextItem,
} from "../../../../domain/document/items";
import { ModelEditableMixin } from "../../../system/mixins";
import { UserDefinitionSelectResult, UserDefinitionSelectItem } from "../dialogs";
import { DocumentStructureEditableMixin } from "../mixins";
import { UserDefinitionWindowKinds } from "../../../../domain/document";
import { KeyValuePair } from "../../../../domain/system";

@Component
export default class UserDefinitionEditor extends Mixins(
  ModelEditableMixin,
  DocumentStructureEditableMixin
) {
  public async applySelectedInformation(source: IUserDefinitionItem, result: UserDefinitionSelectResult): Promise<void> {
    if (!result) { return; }
    if (result.isBlank) {
      this.setUserDefinitionAsFreeInput(source);
      return;
    }
    if (source.userDefinitionWindowKind === UserDefinitionWindowKinds.Institution) {
      this.selectedInstitution = result.institution;
    }
    // 発生元のオブジェクトを最後に処理しないと選択中のオブジェクトが正しく反映しない模様。
    // その後フォントサイズ等TOOL系にあるプロパティを変更した際、valueが更新前の値で再更新されてしまう。
    result.items.sort((a, b) => this.isUserDefinitionNameMatched(source, source.userDefinitionKey, source.groupName, a.name)
      ? 1
      : -1);
    if (!source.groupName) {
      // groupNameが指定されていない場合は発生元のオブジェクトにだけ値をセットする
      this.applyUserSelectResultTextToSelf(result.items, source);
    } else {
      this.applyUserSelectResultTextToGroup(result.items, source.userDefinitionKey, source.groupName);
    }
  }

  private applyUserSelectResultTextToSelf(resultItems: UserDefinitionSelectItem[], source: IUserDefinitionItem): void {
    for (const resultItem of resultItems) {
      const cloned = this.createValueApplyedClone(source, source.userDefinitionKey, source.groupName, resultItem.name, resultItem.values, resultItems);
      if (cloned) {
        this.updateItem(cloned);
      }
    }
  }

  private applyUserSelectResultTextToGroup(resultItems: UserDefinitionSelectItem[], userDefinitionKey: string, groupName: string): void {
    for (const resultItem of resultItems) {
      for (const item of this.items) {
        const cloned = this.createValueApplyedClone(item, userDefinitionKey, groupName, resultItem.name, resultItem.values, resultItems);
        if (cloned) {
          // TODO: 一度のイベントで更新済ませたい
          this.updateItem(cloned);
        }
      }
    }
  }

  private createValueApplyedClone(item: IItem, userDefinitionKey: string, groupName: string, itemName: string, values: string[], resultItems: UserDefinitionSelectItem[]): IItem {
    if (!instanceOfIUserDefinitionItem(item)) { return null; }
    if (!this.isUserDefinitionNameMatched(item, userDefinitionKey, groupName, itemName)) { return null; }
    if (item instanceof AbstractPlainTextItem && item.shouldInputFree) {
      this.$logger.debug("フリー入力状態のため、ユーザ定義の入力をスキップします。");
      return null;
    }
    const cloned = item.clone() as IUserDefinitionItem;
    cloned.setUserDefinitionValues(values);
    cloned.adjustObjectHeight();
    cloned.adjustFontSize();
    const linkName = this.getUserDefineLinkName(item);
    if (linkName) {
      // イベント経由で更新しているので、同じitemに対しては一度のupdateItemで更新する必要がある
      const relatedValues = this.getLinkedValues(linkName, resultItems);
      cloned.setUserDefinitionLinkValues(relatedValues);
    } else {
      cloned.setUserDefinitionLinkValues(null);
    }
    return cloned;
  }

  private isUserDefinitionNameMatched(target: IUserDefinitionItem, userDefinitionKey: string, groupName: string, itemName: string): boolean {
    if (userDefinitionKey !== target.userDefinitionKey) { return false; }
    if (itemName !== target.itemName) { return false; }
    if (!groupName) { return !target.groupName; }
    return groupName === target.groupName;
  }

  private getUserDefineLinkName(source: IUserDefinitionItem): string {
    const linkActions = source.userDefineLinkActions;
    if (!linkActions || linkActions.length === 0) { return null; }
    return linkActions[0].name;
  }

  private getLinkedValues(linkName: string, items: UserDefinitionSelectItem[]): string[] {
    for (const item of items) {
      if (item.name === linkName) { return item.values; }
    }
    return [];
  }

  private setUserDefinitionAsFreeInput(source: IUserDefinitionItem): void {
    // CSVが無い時にフリー入力にしてフォーカスを当てたいが、一括して変更すると
    // 最後のオブジェクトにフォーカスが当たってしまうので、ひとつだけ変更するようにしている
    const cloned = source.clone() as IUserDefinitionItem;
    cloned.changeInputMethodExceptUserDefinitionSelect();
    this.updateItem(cloned);
  }

  public getInitialFilterParameters(source: IUserDefinitionItem): KeyValuePair<string, string>[] {
    if (!source.userDefineSearchActions) { return []; }
    const parameters: KeyValuePair<string, string>[] = [];
    for (const searchAction of source.userDefineSearchActions) {
      // 現在選択中のページのitemSetのitemsを使う
      for (const item of this.items) {
        if (!instanceOfITextDrawable(item)) { continue; }
        // 対象のページキーと名称の情報も持っているが、基本的にはobjectIdで問題無い見込み
        if (!searchAction.valueObjectId || searchAction.valueObjectId !== item.id) { continue; }
        const parameter = new KeyValuePair<string, string>();
        parameter.key = searchAction.name;
        parameter.value = item.text();
        parameters.push(parameter);
      }
    }
    return parameters;
  }
}
